import { render, staticRenderFns } from "./RegistrarReport.vue?vue&type=template&id=a6f5fe32&"
import script from "./RegistrarReport.vue?vue&type=script&lang=js&"
export * from "./RegistrarReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports